import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const FeaturedProductContainer = superstyled({
  tag: Box,
  name: 'FeaturedProducts',
  slot: 'FeaturedProductContainer',
  styles: ({ theme }) => ({
    borderRadius: '1rem',
    padding: '1.5rem',
    display: 'grid',
    columnGap: '1.5rem',
    alignItems: 'center',
    gridTemplateColumns: 'max-content auto min-content',
    [theme.breakpoints.down('md')]: {
      gridTemplateRows: '1fr',
      gridTemplateColumns: 'auto min-content',
    },
  }),
});

export const FeaturedProductDetails = superstyled({
  tag: Stack,
  name: 'FeaturedProducts',
  slot: 'FeaturedProductDetails',
  styles: ({ theme }) => ({
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
    [theme.breakpoints.down('md')]: {
      gridRow: 2,
      gridColumn: '1/-1',
    },
  }),
});

export const FeaturedProductsContainer = superstyled({
  tag: Box,
  name: 'FeaturedProducts',
  slot: 'FeaturedProductsContainer',
  styles: {
    gridRow: 1,
  },
});
